// ----------------------------------------------------------------------
// <copyright file="Izenda.Mapping.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Mapping component
 */
!(function () {
  var React = require('react');
  var MobxPropTypes = require('mobx-react').propTypes;
  var ReactDOM = require('react-dom');
  var observable = require('mobx').observable;
  var constants = require('logic/data/Izenda.DatabaseMappingConstants');
  var TABLE_DEF = constants.TABLE_DEF;
  var connect = require('share/enhancers/Izenda.Connect');
  var Dimensions = require('share/components/hoc/Izenda.Dimensions');
  var Validator = require('share/components/hoc/Izenda.Validator');

  var DropDown = Validator()(require('share/components/controls/Izenda.DropDown'));
  var Table = require('share/components/controls/DataGrid/Izenda.Table').Table;
  var Column = require('share/components/controls/DataGrid/Izenda.Table').Column;
  var ColumnGroup = require('share/components/controls/DataGrid/Izenda.Table').ColumnGroup;
  var Select = Validator()(require('share/components/controls/multiSelectBox/Izenda.Select'));
  var ValidatableInput = Validator()(require('share/components/controls/Izenda.Input'));
  var MergeDuplicateMapping = require('./Izenda.MergeDuplicateMapping');

  var actions = require('./Izenda.MappingDetailActions');

  var Mapping = React.createClass({
    propTypes: {
      store: MobxPropTypes.observableObject.isRequired
    },
    render: function () {
      var props = this.props;
      var size = this.size;

      /*
      * Render Mapping Table.
      */
      var renderMappingTable = function () {
        var localization = props.localization;
        var databaseMappingDetail = props.store.databaseMappingDetail;
        var dataSource = databaseMappingDetail.selectedMappings;
        var doesShowMergeDuplicateMapping = databaseMappingDetail.doesShowMergeDuplicateMapping;
        var height = size.height;
        doesShowMergeDuplicateMapping && (height = height - constants.MAPPING_HEIGHT);

        return (
          <Table
            dataSource={dataSource}
            minHeight={height}>
            <ColumnGroup title={localization.getText('COMMON_LABEL_FROM')}>
              <Column {...TABLE_DEF['fromDatabaseName']}
                cell={renderFromDatabaseName} />
              <Column {...TABLE_DEF['type']}
                cell={renderType} />
              <Column {...TABLE_DEF['fromObject']}
                cell={renderFromObject} />
            </ColumnGroup>
            <ColumnGroup title={localization.getText('COMMON_LABEL_TO')}>
              <Column {...TABLE_DEF['toDatabaseName']}
                cell={renderToDatabaseName} />
              <Column {...TABLE_DEF['toObject']}
                cell={renderToObject} />
              <Column {...TABLE_DEF['tenant']}
                cell={renderTenant} />
            </ColumnGroup>
            <ColumnGroup title='&nbsp;'>
              <Column {...TABLE_DEF['action']}
                cell={renderActionColumn} />
            </ColumnGroup>
          </Table>
        );
      };

      /*
      * Render From Database column
      */
      var renderFromDatabaseName = function (mappingItem, key, rowIndex, column) {
        var store = props.store;

        var onChangeMappingItem = props.onChangeDatabaseName.bind(this, 'fromDatabaseName', mappingItem);
        var value = mappingItem.optionFromDatabaseNameValue && {
          valueField: mappingItem.optionFromDatabaseNameValue,
          labelField: mappingItem.fromDatabaseName,
          optionTooltip: mappingItem.optionFromTooltipValue
        };

        var options = store.fromDatabaseNameDataSource.items.length > 0 ? store.fromDatabaseNameDataSource.items : [];
        return (
          <Select
            options={options}
            simpleValue
            searchable={false}
            onChange={onChangeMappingItem}
            value={value}
            valueKey='valueField'
            labelKey='labelField'
            optionTooltip='optionTooltip'
            validations={constants.REQUIRE_CONSTRAINT}
            isLazyLoading
            isLastPage={store.fromDatabaseNameDataSource.isLastPage}
            getData={store.loadDatabaseNames.bind(store, true)} />
        );
      };

      /*
      * Render To Database column
      */
      var renderToDatabaseName = function (mappingItem, key, rowIndex, column) {
        var store = props.store;

        var onChangeMappingItem = props.onChangeDatabaseName.bind(this, 'toDatabaseName', mappingItem);
        var value = mappingItem.optionToDatabaseNameValue && {
          valueField: mappingItem.optionToDatabaseNameValue,
          labelField: mappingItem.toDatabaseName,
          optionTooltip: mappingItem.optionToTooltipValue
        };
        var options = store.toDatabaseNameDataSource.items.length > 0 ? store.toDatabaseNameDataSource.items : [];

        return (
          <Select
            options={options}
            simpleValue
            searchable={false}
            onChange={onChangeMappingItem}
            value={value}
            valueKey='valueField'
            labelKey='labelField'
            optionTooltip='optionTooltip'
            field={key + rowIndex}
            validations={constants.REQUIRE_CONSTRAINT}
            isLazyLoading
            isLastPage={store.toDatabaseNameDataSource.isLastPage}
            getData={store.loadDatabaseNames.bind(store, false)}
            disabled={mappingItem.isMappingToGridDisabled} />
        );
      };

      /*
      * Render Type column
      */
      var renderType = function (mappingItem, key, rowIndex, column) {
        var onChangeMappingItem = props.onChangeType.bind(this, key, mappingItem);

        return (
          <DropDown options={props.store.typeOptions}
            onChange={onChangeMappingItem}
            value={mappingItem[key]}
            additionalKey={key + rowIndex} />
        );
      };

      /*
      * Render From Object column.
      */
      var renderFromObject = function (mappingItem, key, rowIndex, column) {
        var store = props.store;
        var onChangeMappingItem = props.onChangeMappingItem.bind(this, key, mappingItem);
        var disabled = mappingItem.type === constants.MAPPING_TYPE.Database;
        var dataSource = store.getObjectDataSource(mappingItem.optionFromDatabaseNameValue);
        var dataSourceDetail = dataSource && (mappingItem.type === constants.MAPPING_TYPE.Schema ? dataSource.schemaObjects : dataSource.databaseObject);

        var value = mappingItem.fromObject && {
          valueField: mappingItem.fromObject,
          labelField: mappingItem.fromObject
        };

        var options = (dataSourceDetail && dataSourceDetail.items.length > 0)
                      ? dataSourceDetail.items
                      : [];

        return (
          <Select
            options={options}
            simpleValue
            searchable={false}
            onChange={onChangeMappingItem}
            value={value}
            valueKey='valueField'
            labelKey='labelField'
            field={key + rowIndex}
            validations={constants.REQUIRE_CONSTRAINT}
            disabled={disabled}
            isLazyLoading
            isLastPage={dataSourceDetail ? dataSourceDetail.isLastPage : false}
            getData={store.loadObjects.bind(store, mappingItem)} />
        );
      };

      /*
      * Render To Object column
      */
      var renderToObject = function (mappingItem, key, rowIndex, column) {
        var onChangeMappingItem = props.onChangeMappingItem.bind(this, key, mappingItem);
        return (
          <ValidatableInput
            onChange={onChangeMappingItem}
            value={mappingItem[key]}
            className='form-control'
            field={key + rowIndex}
            maxLength={256}
            validations={constants.REQUIRE_CONSTRAINT}
            disabled={mappingItem.isMappingToGridDisabled} />
        );
      };

      /**
      * Render Tenant(s) column
      */
      var renderTenant = function (mappingItem, key, rowIndex, column) {
        var options = props.store.tenantOptions;
        var localization = props.localization;

        return (<div className='select-box'>
          <Select
            multi
            simpleValue
            options={options}
            labelKey='displayValue'
            valueKey='id'
            noResultsText={localization.getText('COMMON_MESSAGES_NO_RESULT')}
            allowCreate={false}
            onChange={mappingItem.updateMappingTenant.bind(mappingItem)}
            value={mappingItem.displayTenants}
            field={key + rowIndex}
            validations={constants.REQUIRE_CONSTRAINT}
            disabled={mappingItem.isMappingToGridDisabled} />
        </div>);
      };

      /*
      * Render Action Column
      */
      var renderActionColumn = function (mappingItem, key, rowIndex, column) {
        var onDeleteMapping = props.onDeleteMapping.bind(this, mappingItem);
        var localization = props.localization;
        return (
          <div>
            <a onClick={onDeleteMapping} className='action-column'>
              <span title={localization.getText('COMMON_LABEL_DELETE')}
                className='icon-cancel' />
            </a>
            {mappingItem.showMessage && <span title={mappingItem.message}
              className='icon-info-circled u_textErrorColor' />}
          </div>

        );
      };

      var databaseMappingDetail = props.store.databaseMappingDetail;
      return (
        <div className='izenda-MappingDetail'>
          {databaseMappingDetail.doesShowMergeDuplicateMapping && <MergeDuplicateMapping store={props.store} />}
          {renderMappingTable()}
        </div>
      );
    },

    componentDidMount: function () {
      var dom = ReactDOM.findDOMNode(this);      
      var newHeight = dom.clientHeight;
      newHeight > 0 &&
        newHeight !== this.size.height &&
        (this.size.height = newHeight);
    },

    componentWillMount: function() {
      this.size = observable({ height: this.props.height });
    },

    componentWillReceiveProps: function(nextProps) {
      this.size.height = nextProps.height;
    }
  });

  module.exports = connect(actions, Dimensions)(Mapping);
}());


// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/DatabaseMapping/MappingDetail/Izenda.Mapping.jsx